import React, { useMemo, useRef, useState } from "react";
import { faQuestionCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

//general buttons
import editButtonGreen from "../../img/autoayuda/autoayuda-farminfo-3.png";
import editButtonRed from "../../img/autoayuda/autoayuda-farminfo-4.png";

//nodeMap
import mapBtnNode1 from "../../img/autoayuda/autoayuda-nodemap-button-1.png";
import mapBtnNode2 from "../../img/autoayuda/autoayuda-nodemap-button-2.png";

//zoneMap
import mapBtnZone1 from "../../img/autoayuda/autoayuda-zonemap-button-1.png";
import mapBtnZone12 from "../../img/autoayuda/autoayuda-zonemap-button-1-2.png";
import mapBtnZone2 from "../../img/autoayuda/autoayuda-zonemap-button-2.png";
import mapBtnZone22 from "../../img/autoayuda/autoayuda-zonemap-button-2-2.png";
import mapBtnZone3 from "../../img/autoayuda/autoayuda-zonemap-button-3.png";
import TooltipPrime from "../PrimeComponents/TooltipPrime";
import { TabView, TabPanel } from "primereact/tabview";
import { Dialog } from "primereact/dialog";

const Tab = ({ introText, child, definition, nodeSensTable }) => {
    return (
        <div className="container-selfhelp">
            {!nodeSensTable ?
                <>
                    {!definition ?
                        <>
                            {child.map((p) => {
                                return (
                                    <div key={p.id}>
                                        <div className="row">
                                            <div className="col-xs-12 text-md-left text-center col-md-1"><span className="selfHelpNumbers">{p.id}</span></div>
                                            <div className="col">
                                                {p.text.includes("\n") ?
                                                    p.text.split("\n").map((t, i) => {
                                                        return (
                                                            t.includes("<link>") ?
                                                                <>
                                                                    <span className="selfHelpDescription">{t.split("<link>")[0]}</span>
                                                                    <a className="selfHelpDescription" href={`${t.split("<link>").pop().split("</link>")[0]}`} target="_blank" rel="noopener noreferrer">DGA</a>
                                                                </>
                                                                :
                                                                <>
                                                                    <span key={i} className="selfHelpDescription">{t}</span>
                                                                    <br />
                                                                </>
                                                        );
                                                    })
                                                    :
                                                    <span className="selfHelpDescription">{p.text}</span>}
                                                <div>
                                                    {Array.isArray(p.image) ?
                                                        <>
                                                            {p.image.map((img, i) => {
                                                                return (
                                                                    <>
                                                                        <img key={i} src={img} className='selfHelpImages msg' alt="" />
                                                                        <br />
                                                                    </>
                                                                );
                                                            })}
                                                        </>
                                                        :
                                                        <img src={p.image} className='selfHelpImages' alt="selfHelp" />}
                                                </div>

                                            </div>
                                        </div>
                                        <hr className="selfHelpLine" />
                                    </div>
                                );
                            })}
                        </>
                        :
                        <div className="container-properties">
                            <div className="containter-definitions">
                                {child.map(c => {
                                    return (
                                        <div key={c.defName} className="mb-1">
                                            <span className="definition-name font-weight-bold">{c.defName}</span>
                                            <span className="definition-text">{c.defText}</span>
                                        </div>
                                    );
                                })}
                            </div>
                        </div>}
                </>
                :
                <div className="container-properties">
                    <div className="containter-definitions">
                        <span className="definition-text">{introText}</span>
                        <hr className="selfHelpLine" />
                        {child.map(c => {
                            return (
                                <div key={c.title} className="mb-1">
                                    <span className="definition-name font-weight-bold">{c.title}</span>
                                    <span className="definition-text">{c.text}</span>
                                    <img src={c.image} style={{ width: "570px" }} alt="selfHelp" />
                                    <hr className="selfHelpLine" />
                                </div>
                            );
                        })}
                    </div>
                </div>}
        </div >
    );
};

const HelperFertiTable = ({ params }) => {
    if (!params) return null;
    return (
        <div>
            <TabView className='tab-prime-selfhelp'>
                {params.map((p) => {
                    return (
                        <TabPanel key={p.tab} header={p.header.text} >
                            <Tab key={p.tab} child={p.params} definition={p.definition} />
                        </TabPanel>
                    );
                })}
            </TabView>
        </div>
    );
};

const HelperNodeSensTable = ({ params}) => {
    if (!params) return null;

    return (
        <div>
            <TabView className='tab-prime-selfhelp'>
                {params.map((p) => {
                    return (
                        <TabPanel key={p.tab} header={p.header.text} >
                            <Tab key={p.tab} child={p.params} introText={p.introText} nodeSensTable />
                        </TabPanel>
                    );
                })}
            </TabView>
        </div>
    );
};

const SelfHelp = ({ t, params, images, lng, zonesTableEditable, zoneForm, zoneMap, nodeMap,
    simpleEditTable, onlyDict, userTable, blockTable, fertiTable, nodeSensTable, target }) => {

    const [dialogState, setDialogState] = useState(false);
    const selfHelpRef = useRef(null);

    const tabNames = useMemo(() => [{ text: t("selfHelp.instructions") }, { text: t("selfHelp.properties") }], [t]);
    const tabNamesIfZonesTable = useMemo(() => [
        { text: t("selfHelp.instructionSimpleEdit") },
        { text: t("selfHelp.instructionMassEdit") },
        { text: t("selfHelp.properties") }
    ], [t]);

    const tabNamesUserTable = useMemo(() => [{ text: t("selfHelp.instructionEdit") }, { text: t("selfHelp.instructionAddUser") }], [t]);
    const tabNamesReportsTable = useMemo(() => [
        { text: t("selfHelp.instructionAdd") },
        { text: t("selfHelp.instructionEdit") },
        { text: t("selfHelp.instructionMassEdit") },
        { text: t("forms.tituloParametrosGenerales") }
    ], [t]);

    if ((!images && Array.isArray(images) && images.length < 1)) return null;

    //ZONESTABLE
    const SimpleEdition = () => {
        return (
            <div className="container-selfhelp">
                <div className="row">
                    <div className="col-xs-12 text-md-left text-center col-md-1"><span className="selfHelpNumbers">1</span></div>
                    <div className="col">
                        <span className="selfHelpDescription">{t("selfHelp.farmInfo.msg1")}</span>
                        <div>
                            <img src={images[0]} className='selfHelpImages' alt="selfHelp" />
                        </div>
                    </div>
                </div>
                <hr className="selfHelpLine" />
                <div className="row">
                    <div className="col-xs-12 text-md-left text-center col-md-1"><span className="selfHelpNumbers">2</span></div>
                    <div className="col">
                        <div className="selfHelpDescription">
                            <span>
                                {t("selfHelp.farmInfo.msg2")}
                            </span>
                        </div>
                        <div>
                            <img src={images[1]} className='selfHelpImages' alt="selfHelp" />
                        </div>
                    </div>
                </div>
                <hr className="selfHelpLine" />
                <div className="row">
                    <div className="col-xs-12 text-md-left text-center col-md-1"><span className="selfHelpNumbers">3</span></div>
                    <div className="col">
                        <span className="selfHelpDescription">{t("selfHelp.tableButtons.msgSave")}</span>
                        <div>
                            <img src={import.meta.glob("../../img/autoayuda/*/autoayuda-farminfo-zonetable-buttons-1.png", { eager: true, import: "default" })[`../../img/autoayuda/${lng}/autoayuda-farminfo-zonetable-buttons-1.png`]} alt="selfHelp" />
                        </div>
                    </div>

                    <div className="col">
                        <span className="selfHelpDescription">{t("selfHelp.tableButtons.msgCancel")}</span>
                        <div>
                            <img src={import.meta.glob("../../img/autoayuda/*/autoayuda-farminfo-zonetable-buttons-2.png", { eager: true, import: "default" })[`../../img/autoayuda/${lng}/autoayuda-farminfo-zonetable-buttons-2.png`]} alt="selfHelp" />
                        </div>
                    </div>
                </div>
                <hr className="selfHelpLine" />
                <div className="row">
                    <div className="col-xs-12 text-md-left text-center col-md-1"><span className="selfHelpNumbers">4</span></div>
                    <div className="col">
                        <div className="row">
                            <div className="col">
                                <span className="selfHelpDescription">{t("selfHelp.msgSuccess")}</span>
                                <div>
                                    <img src={import.meta.glob("../../img/autoayuda/*/autoayuda-success.png", { eager: true, import: "default" })[`../../img/autoayuda/${lng}/autoayuda-success.png`]} className='selfHelpImages msg' alt="selfHelp" />
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col">
                                <span className="selfHelpDescription">{t("selfHelp.msgInfo")}</span>
                                <div>
                                    <img src={import.meta.glob("../../img/autoayuda/*/autoayuda-info.png", { eager: true, import: "default" })[`../../img/autoayuda/${lng}/autoayuda-info.png`]} className='selfHelpImages msg' alt="selfHelp" />
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col">
                                <span className="selfHelpDescription">{t("selfHelp.msgError")}</span>
                                <div>
                                    <img src={import.meta.glob("../../img/autoayuda/*/autoayuda-error.png", { eager: true, import: "default" })[`../../img/autoayuda/${lng}/autoayuda-error.png`]} className='selfHelpImages msg' alt="selfHelp" />
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        );
    };

    const MassEdition = () => {
        return (
            <div className="container-selfhelp">
                <div className="row">
                    <div className="col-xs-12 text-md-left text-center col-md-1"><span className="selfHelpNumbers">1</span></div>
                    <div className="col">
                        <span className="selfHelpDescription">{t("selfHelp.massEdit.msg1")}</span>
                        <div>
                            <img src={import.meta.glob("../../img/autoayuda/*/autoayuda-farminfo-zonetable-mass-1.png", { eager: true, import: "default" })[`../../img/autoayuda/${lng}/autoayuda-farminfo-zonetable-mass-1.png`]} className='selfHelpImages' alt="selfHelp" />
                        </div>
                    </div>
                </div>
                <hr className="selfHelpLine" />
                <div className="row">
                    <div className="col-xs-12 text-md-left text-center col-md-1"><span className="selfHelpNumbers">2</span></div>
                    <div className="col">
                        <div className="selfHelpDescription"><span>{t("selfHelp.massEdit.msg2")}</span></div>
                        <div>
                            <img src={import.meta.glob("../../img/autoayuda/*/autoayuda-farminfo-zonetable-mass-2.png", { eager: true, import: "default" })[`../../img/autoayuda/${lng}/autoayuda-farminfo-zonetable-mass-2.png`]} className='selfHelpImages' alt="selfHelp" />
                        </div>
                    </div>
                </div>
                <hr className="selfHelpLine" />
                <div className="row">
                    <div className="col-xs-12 text-md-left text-center col-md-1"><span className="selfHelpNumbers">3</span></div>
                    <div className="col">
                        <span className="selfHelpDescription">{t("selfHelp.massEdit.msg3")}</span>
                        <div>
                            <img src={import.meta.glob("../../img/autoayuda/*/autoayuda-farminfo-zonetable-mass-3.png", { eager: true, import: "default" })[`../../img/autoayuda/${lng}/autoayuda-farminfo-zonetable-mass-3.png`]} alt="selfHelp" />
                        </div>
                    </div>
                </div>
                <hr className="selfHelpLine" />
                <div className="row">
                    <div className="col-xs-12 text-md-left text-center col-md-1"><span className="selfHelpNumbers">4</span></div>
                    <div className="col">
                        <span className="selfHelpDescription">{t("selfHelp.massEdit.msg4")}</span>
                        <div>
                            <img src={import.meta.glob("../../img/autoayuda/*/autoayuda-farminfo-zonetable-mass-4.png", { eager: true, import: "default" })[`../../img/autoayuda/${lng}/autoayuda-farminfo-zonetable-mass-4.png`]} alt="selfHelp" />
                        </div>
                    </div>
                </div>
                <hr className="selfHelpLine" />
                <div className="row">
                    <div className="col-xs-12 text-md-left text-center col-md-1"><span className="selfHelpNumbers">5</span></div>
                    <div className="col">
                        <div className="row">
                            <div className="col">
                                <span className="selfHelpDescription">{t("selfHelp.msgSuccess")}</span>
                                <div>
                                    <img src={import.meta.glob("../../img/autoayuda/*/autoayuda-success.png", { eager: true, import: "default" })[`../../img/autoayuda/${lng}/autoayuda-success.png`]} className='selfHelpImages msg' alt="selfHelp" />
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col">
                                <span className="selfHelpDescription">{t("selfHelp.msgInfo")}</span>
                                <div>
                                    <img src={import.meta.glob("../../img/autoayuda/*/autoayuda-info.png", { eager: true, import: "default" })[`../../img/autoayuda/${lng}/autoayuda-info.png`]} className='selfHelpImages msg' alt="selfHelp" />
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col">
                                <span className="selfHelpDescription">{t("selfHelp.msgError")}</span>
                                <div>
                                    <img src={import.meta.glob("../../img/autoayuda/*/autoayuda-error.png", { eager: true, import: "default" })[`../../img/autoayuda/${lng}/autoayuda-error.png`]} className='selfHelpImages msg' alt="selfHelp" />
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        );
    };

    const PropertiesZone = () => {
        if (!params) return null;
        return (
            <div className="container-properties">
                <div className="containter-definitions">
                    <span className="header-properties">{t("selfHelp.definitionsHeader")}</span>
                    <ul>
                        {Array.isArray(params.definitionName) && Array.isArray(params.definitionText) && params.definitionName.map((p, index) => {
                            return (
                                <li className="param-properties" key={index}>
                                    <span className="definition-name">{p}: </span>
                                    <span className="definition-text">{params.definitionText[index]}</span>
                                </li>
                            );
                        })}
                    </ul>
                </div>
                <div className="container-editables">
                    <span className="header-properties">{params.header}</span>
                    <ul>
                        <span className="titulo-parametros">{t("forms.tituloParametrosGenerales")}</span>
                        <hr className="titulo-parametro-hr" />
                        {Array.isArray(params.paramsGeneral) && params.paramsGeneral.map((p, index) => {
                            return (
                                p && <li className="param-properties" key={`general-${index}`}>{p}</li>
                            );
                        })}
                        <span className="titulo-parametros">{t("forms.tituloParametrosRiego")}</span>
                        <hr className="titulo-parametro-hr" />
                        {Array.isArray(params.paramsRiego) && params.paramsRiego.map((p, index) => {
                            return (
                                p && <li className="param-properties" key={`riego-${index}`}>{p}</li>
                            );
                        })}
                        <span className="titulo-parametros">{t("forms.tituloParametrosSuelo")}</span>
                        <hr className="titulo-parametro-hr" />
                        {Array.isArray(params.paramsSuelo) && params.paramsSuelo.map((p, index) => {
                            return (
                                p && <li className="param-properties" key={`suelo-${index}`}>{p}</li>
                            );
                        })}
                        <span className="titulo-parametros">{t("forms.tituloParametrosClima")}</span>
                        <hr className="titulo-parametro-hr" />
                        {Array.isArray(params.paramsClima) && params.paramsClima.map((p, index) => {
                            return (
                                p && <li className="param-properties" key={`clima-${index}`}>{p}</li>
                            );
                        })}
                    </ul>
                </div>
            </div>
        );
    };
    //

    const InstructionsZoneMap = () => {
        return (
            <div className="container-selfhelp">
                <div className="row">
                    <div className="col-xs-12 text-md-left text-center col-md-1"><span className="selfHelpNumbers">1</span></div>
                    <div className="col">
                        <span className="selfHelpDescription">{t("selfHelp.nodeMap.msg1")}</span>
                        <div><img src={images[0]} className='selfHelpImages' alt="selfHelp" /></div>
                    </div>
                </div>
                <hr className="selfHelpLine" />
                <div className="row">
                    <div className="col-xs-12 text-md-left text-center col-md-1"><span className="selfHelpNumbers">2</span></div>
                    <div className="col">
                        <span className="selfHelpDescription">{t("selfHelp.zoneMap.msg1")}<b> ({t("selfHelp.nodeMap.msg2-skip")} 8)</b></span>
                        <div><img src={images[2]} className='selfHelpImages' alt="selfHelp" /></div>
                    </div>
                </div>
                <hr className="selfHelpLine" />
                <div className="row">
                    <div className="col-xs-12 text-md-left text-center col-md-1"><span className="selfHelpNumbers">3</span></div>
                    <div className="col">
                        <span className="selfHelpDescription">{t("selfHelp.zoneMap.msg2")}</span>
                        <div><span className="selfHelpDescription">{t("selfHelp.zoneMap.msg3")}</span></div>
                        <div><img src={mapBtnZone1} className='selfHelpImages buttons-map' alt="selfHelp" /></div>
                    </div>
                </div>
                <hr className="selfHelpLine" />
                <div className="row">
                    <div className="col-xs-12 text-md-left text-center col-md-1"><span className="selfHelpNumbers">4</span></div>
                    <div className="col">
                        <div className="selfHelpDescription"><span>{t("selfHelp.zoneMap.msg4")}<b> ({t("selfHelp.nodeMap.msg2-skip")} 8)</b></span></div>
                        <div><img src={mapBtnZone12} className='selfHelpImages' alt="selfHelp" /></div>
                    </div>
                </div>
                <hr className="selfHelpLine" />
                <div className="row">
                    <div className="col-xs-12 text-md-left text-center col-md-1"><span className="selfHelpNumbers">5</span></div>
                    <div className="col">
                        <span className="selfHelpDescription">{t("selfHelp.zoneMap.msg2")}</span>
                        <div><span className="selfHelpDescription">{t("selfHelp.zoneMap.msg3")}</span></div>
                        <div><img src={mapBtnZone2} className='selfHelpImages buttons-map' alt="selfHelp" /></div>
                    </div>
                </div>
                <hr className="selfHelpLine" />
                <div className="row">
                    <div className="col-xs-12 text-md-left text-center col-md-1"><span className="selfHelpNumbers">6</span></div>
                    <div className="col">
                        <div className="selfHelpDescription"><span>{t("selfHelp.zoneMap.msg5")}<b> ({t("selfHelp.nodeMap.msg2-skip")} 8)</b></span></div>
                        <div><img src={mapBtnZone22} className='selfHelpImages' alt="selfHelp" /></div>
                    </div>
                </div>
                <hr className="selfHelpLine" />
                <div className="row">
                    <div className="col-xs-12 text-md-left text-center col-md-1"><span className="selfHelpNumbers">7</span></div>
                    <div className="col">
                        <span className="selfHelpDescription">{t("selfHelp.zoneMap.msg6")}</span>
                        <div><img src={mapBtnZone3} className='selfHelpImages buttons-map' alt="selfHelp" /></div>
                    </div>
                </div>
                <hr className="selfHelpLine" />
                <div className="row">
                    <div className="col-xs-12 text-md-left text-center col-md-1"><span className="selfHelpNumbers">8</span></div>
                    <div className="col">
                        <span className="selfHelpDescription">{t("selfHelp.farmInfo.msg3")}</span>
                        <div><img src={editButtonGreen} className='selfHelpImages buttons' alt="selfHelp" /></div>
                    </div>
                    <div className="col">
                        <span className="selfHelpDescription">{t("selfHelp.farmInfo.msg4")}</span>
                        <div><img src={editButtonRed} className='selfHelpImages buttons' alt="selfHelp" /></div>
                    </div>
                </div>
                <hr className="selfHelpLine" />
                <div className="row">
                    <div className="col-xs-12 text-md-left text-center col-md-1"><span className="selfHelpNumbers">9</span></div>
                    <div className="col">
                        <div className="row">
                            <div className="col">
                                <span className="selfHelpDescription">{t("selfHelp.msgSuccess")}</span>
                                <div><img src={import.meta.glob("../../img/autoayuda/*/autoayuda-success.png", { eager: true, import: "default" })[`../../img/autoayuda/${lng}/autoayuda-success.png`]} className='selfHelpImages msg' alt="selfHelp" /></div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col">
                                <span className="selfHelpDescription">{t("selfHelp.msgInfo")}</span>
                                <div><img src={import.meta.glob("../../img/autoayuda/*/autoayuda-info.png", { eager: true, import: "default" })[`../../img/autoayuda/${lng}/autoayuda-info.png`]} className='selfHelpImages msg' alt="selfHelp" /></div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col">
                                <span className="selfHelpDescription">{t("selfHelp.msgError")}</span>
                                <div><img src={import.meta.glob("../../img/autoayuda/*/autoayuda-error.png", { eager: true, import: "default" })[`../../img/autoayuda/${lng}/autoayuda-error.png`]} className='selfHelpImages msg' alt="selfHelp" /></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    };


    const InstructionsNodeMap = () => {
        return (
            <div className="container-selfhelp">
                <div className="row">
                    <div className="col-xs-12 text-md-left text-center col-md-1"><span className="selfHelpNumbers">1</span></div>
                    <div className="col">
                        <span className="selfHelpDescription">{t("selfHelp.nodeMap.msg1")}</span>
                        <div><img src={images[0]} className='selfHelpImages' alt="selfHelp" /></div>
                    </div>
                </div>
                <hr className="selfHelpLine" />
                <div className="row">
                    <div className="col-xs-12 text-md-left text-center col-md-1"><span className="selfHelpNumbers">2</span></div>
                    <div className="col">
                        <span className="selfHelpDescription">{t("selfHelp.nodeMap.msg2")}<b> ({t("selfHelp.nodeMap.msg2-skip")} 6)</b></span>
                        <div><img src={images[1]} className='selfHelpImages' alt="selfHelp" /></div>
                    </div>
                </div>
                <hr className="selfHelpLine" />
                <div className="row">
                    <div className="col-xs-12 text-md-left text-center col-md-1"><span className="selfHelpNumbers">3</span></div>
                    <div className="col">
                        <span className="selfHelpDescription">{t("selfHelp.nodeMap.msg3")}</span>
                        <div><span className="selfHelpDescription">{t("selfHelp.nodeMap.msg4")}</span></div>
                        <div><img src={mapBtnNode1} className='selfHelpImages buttons-map' alt="selfHelp" /></div>
                    </div>
                </div>
                <hr className="selfHelpLine" />
                <div className="row">
                    <div className="col-xs-12 text-md-left text-center col-md-1"><span className="selfHelpNumbers">4</span></div>
                    <div className="col">
                        <div className="selfHelpDescription"><span>{t("selfHelp.nodeMap.msg5")}</span></div>
                        <div><img src={images[2]} className='selfHelpImages' alt="selfHelp" /></div>
                    </div>
                </div>
                <hr className="selfHelpLine" />
                <div className="row">
                    <div className="col-xs-12 text-md-left text-center col-md-1"><span className="selfHelpNumbers">5</span></div>
                    <div className="col">
                        <span className="selfHelpDescription">{t("selfHelp.nodeMap.msg6")}</span>
                        <div><img src={mapBtnNode2} className='selfHelpImages buttons-map' alt="selfHelp" /></div>
                    </div>
                </div>
                <hr className="selfHelpLine" />
                <div className="row">
                    <div className="col-xs-12 text-md-left text-center col-md-1"><span className="selfHelpNumbers">6</span></div>
                    <div className="col">
                        <div className="selfHelpDescription"><span>{t("selfHelp.nodeMap.msg7")}</span></div>
                        <div><img src={images[3]} className='selfHelpImages' alt="selfHelp" /></div>
                    </div>
                </div>
                <hr className="selfHelpLine" />
                <div className="row">
                    <div className="col-xs-12 text-md-left text-center col-md-1"><span className="selfHelpNumbers">7</span></div>
                    <div className="col">
                        <span className="selfHelpDescription">{t("selfHelp.farmInfo.msg3")}</span>
                        <div><img src={editButtonGreen} className='selfHelpImages buttons' alt="selfHelp" /></div>
                    </div>
                    <div className="col">
                        <span className="selfHelpDescription">{t("selfHelp.farmInfo.msg4")}</span>
                        <div><img src={editButtonRed} className='selfHelpImages buttons' alt="selfHelp" /></div>
                    </div>
                </div>
                <hr className="selfHelpLine" />
                <div className="row">
                    <div className="col-xs-12 text-md-left text-center col-md-1"><span className="selfHelpNumbers">8</span></div>
                    <div className="col">
                        <div className="row">
                            <div className="col">
                                <span className="selfHelpDescription">{t("selfHelp.msgSuccess")}</span>
                                <div><img src={import.meta.glob("../../img/autoayuda/*/autoayuda-success.png", { eager: true, import: "default" })[`../../img/autoayuda/${lng}/autoayuda-success.png`]} className='selfHelpImages msg' alt="selfHelp" /></div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col">
                                <span className="selfHelpDescription">{t("selfHelp.msgInfo")}</span>
                                <div><img src={import.meta.glob("../../img/autoayuda/*/autoayuda-info.png", { eager: true, import: "default" })[`../../img/autoayuda/${lng}/autoayuda-info.png`]} className='selfHelpImages msg' alt="selfHelp" /></div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col">
                                <span className="selfHelpDescription">{t("selfHelp.msgError")}</span>
                                <div><img src={import.meta.glob("../../img/autoayuda/*/autoayuda-error.png", { eager: true, import: "default" })[`../../img/autoayuda/${lng}/autoayuda-error.png`]} className='selfHelpImages msg' alt="selfHelp" /></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    };

    const Instructions = () => {
        if (!images) return null;
        return (
            <div className="container-selfhelp">
                <div className="row">
                    <div className="col-xs-12 text-md-left text-center col-md-1"><span className="selfHelpNumbers">1</span></div>
                    <div className="col">
                        <span className="selfHelpDescription">{t("selfHelp.farmInfo.msg1")}</span>
                        <div><img src={images[0]} className='selfHelpImages' alt="selfHelp" /></div>
                    </div>
                </div>
                <hr className="selfHelpLine" />
                <div className="row">
                    <div className="col-xs-12 text-md-left text-center col-md-1"><span className="selfHelpNumbers">2</span></div>
                    <div className="col">
                        <div className="selfHelpDescription"><span>{t("selfHelp.farmInfo.msg2")}</span></div>
                        <div><img src={images[1]} className='selfHelpImages' alt="selfHelp" /></div>
                    </div>
                </div>
                <hr className="selfHelpLine" />
                <div className="row">
                    <div className="col-xs-12 text-md-left text-center col-md-1"><span className="selfHelpNumbers">3</span></div>
                    <div className="col">
                        <span className="selfHelpDescription">{t("selfHelp.farmInfo.msg3")}</span>
                        <div><img src={editButtonGreen} className='selfHelpImages buttons' alt="selfHelp" /></div>
                    </div>
                    <div className="col">
                        <span className="selfHelpDescription">{t("selfHelp.farmInfo.msg4")}</span>
                        <div><img src={editButtonRed} className='selfHelpImages buttons' alt="selfHelp" /></div>
                    </div>
                </div>
                <hr className="selfHelpLine" />
                <div className="row">
                    <div className="col-xs-12 text-md-left text-center col-md-1"><span className="selfHelpNumbers">4</span></div>
                    <div className="col">
                        <div className="row">
                            <div className="col">
                                <span className="selfHelpDescription">{t("selfHelp.msgSuccess")}</span>
                                <div><img src={import.meta.glob("../../img/autoayuda/*/autoayuda-success.png", { eager: true, import: "default" })[`../../img/autoayuda/${lng}/autoayuda-success.png`]} className='selfHelpImages msg' alt="selfHelp" /></div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col">
                                <span className="selfHelpDescription">{t("selfHelp.msgInfo")}</span>
                                <div><img src={import.meta.glob("../../img/autoayuda/*/autoayuda-info.png", { eager: true, import: "default" })[`../../img/autoayuda/${lng}/autoayuda-info.png`]} className='selfHelpImages msg' alt="selfHelp" /></div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col">
                                <span className="selfHelpDescription">{t("selfHelp.msgError")}</span>
                                <div><img src={import.meta.glob("../../img/autoayuda/*/autoayuda-error.png", { eager: true, import: "default" })[`../../img/autoayuda/${lng}/autoayuda-error.png`]} className='selfHelpImages msg' alt="selfHelp" /></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    };

    const AddUser = () => {
        return (
            <div className="container-selfhelp">
                <div className="row">
                    <div className="col-xs-12 text-md-left text-center col-md-1"><span className="selfHelpNumbers">1</span></div>
                    <div className="col">
                        <span className="selfHelpDescription">{t("selfHelp.userTableAdd.msg1")}</span>
                        <div>
                            <img src={import.meta.glob("../../img/autoayuda/*/autoayuda-usertable-add-1.png", { eager: true, import: "default" })[`../../img/autoayuda/${lng}/autoayuda-usertable-add-1.png`]} className='selfHelpImages' alt="selfHelp" />
                        </div>
                    </div>
                </div>
                <hr className="selfHelpLine" />
                <div className="row">
                    <div className="col-xs-12 text-md-left text-center col-md-1"><span className="selfHelpNumbers">2</span></div>
                    <div className="col">
                        <div className="selfHelpDescription"><span>{t("selfHelp.userTableAdd.msg2")}</span></div>
                        <div>
                            <img src={import.meta.glob("../../img/autoayuda/*/autoayuda-usertable-add-2.png", { eager: true, import: "default" })[`../../img/autoayuda/${lng}/autoayuda-usertable-add-2.png`]} className='selfHelpImages' alt="selfHelp" />
                        </div>
                    </div>
                </div>
                <hr className="selfHelpLine" />
                <div className="row">
                    <div className="col-xs-12 text-md-left text-center col-md-1"><span className="selfHelpNumbers">3</span></div>
                    <div className="col">
                        <div className="selfHelpDescription"><span>{t("selfHelp.userTableAdd.msg3")}</span></div>
                        <div>
                            <img src={import.meta.glob("../../img/autoayuda/*/autoayuda-usertable-add-3.png", { eager: true, import: "default" })[`../../img/autoayuda/${lng}/autoayuda-usertable-add-3.png`]} className='selfHelpImages' alt="selfHelp" />
                        </div>
                    </div>
                </div>
                <hr className="selfHelpLine" />
                <div className="row">
                    <div className="col-xs-12 text-md-left text-center col-md-1"><span className="selfHelpNumbers">4</span></div>
                    <div className="col">
                        <div className="selfHelpDescription"><span>{t("selfHelp.userTableAdd.msg4")}</span></div>
                        <div>
                            <img src={import.meta.glob("../../img/autoayuda/*/autoayuda-usertable-2.png", { eager: true, import: "default" })[`../../img/autoayuda/${lng}/autoayuda-usertable-2.png`]} className='selfHelpImages' alt="selfHelp" />
                        </div>
                    </div>
                </div>
                <hr className="selfHelpLine" />
                <div className="row">
                    <div className="col-xs-12 text-md-left text-center col-md-1"><span className="selfHelpNumbers">3</span></div>
                    <div className="col">
                        <span className="selfHelpDescription">{t("selfHelp.tableButtons.msgSave")}</span>
                        <div>
                            <img src={import.meta.glob("../../img/autoayuda/*/autoayuda-farminfo-zonetable-buttons-1.png", { eager: true, import: "default" })[`../../img/autoayuda/${lng}/autoayuda-farminfo-zonetable-buttons-1.png`]} alt="selfHelp" />
                        </div>
                    </div>

                    <div className="col">
                        <span className="selfHelpDescription">{t("selfHelp.tableButtons.msgCancel")}</span>
                        <div>
                            <img src={import.meta.glob("../../img/autoayuda/*/autoayuda-farminfo-zonetable-buttons-2.png", { eager: true, import: "default" })[`../../img/autoayuda/${lng}/autoayuda-farminfo-zonetable-buttons-2.png`]} alt="selfHelp" />
                        </div>
                    </div>
                </div>
                <hr className="selfHelpLine" />
                <div className="row">
                    <div className="col-xs-12 text-md-left text-center col-md-1"><span className="selfHelpNumbers">5</span></div>
                    <div className="col">
                        <div className="row">
                            <div className="col">
                                <span className="selfHelpDescription">{t("selfHelp.msgSuccess")}</span>
                                <div>
                                    <img src={import.meta.glob("../../img/autoayuda/*/autoayuda-success.png", { eager: true, import: "default" })[`../../img/autoayuda/${lng}/autoayuda-success.png`]} className='selfHelpImages msg' alt="selfHelp" />
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col">
                                <span className="selfHelpDescription">{t("selfHelp.msgInfo")}</span>
                                <div>
                                    <img src={import.meta.glob("../../img/autoayuda/*/autoayuda-info.png", { eager: true, import: "default" })[`../../img/autoayuda/${lng}/autoayuda-info.png`]} className='selfHelpImages msg' alt="selfHelp" />
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col">
                                <span className="selfHelpDescription">{t("selfHelp.msgError")}</span>
                                <div>
                                    <img src={import.meta.glob("../../img/autoayuda/*/autoayuda-error.png", { eager: true, import: "default" })[`../../img/autoayuda/${lng}/autoayuda-error.png`]} className='selfHelpImages msg' alt="selfHelp" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    };


    const Properties = () => {
        if (!params) return null;
        return (
            <div className="container-properties">
                <div className="containter-definitions">
                    {Array.isArray(params.definitionName) && params.definitionName.length > 0 &&
            <span className="header-properties">{t("selfHelp.definitionsHeader")}</span>}
                    <ul>
                        {Array.isArray(params.definitionName) && params.definitionName.length < 1 &&
              Array.isArray(params.definitionText) && params.definitionText.length > 0 && params.definitionText.map((text, index) => {
                            return (
                                <span key={index} className="definition-text">{text}</span>
                            );
                        })}

                        {Array.isArray(params.definitionName) && Array.isArray(params.definitionText) && params.definitionName.map((p, index) => {
                            return (
                                <li className="param-properties" key={index}>
                                    <span className="definition-name">{p}: </span>
                                    <span className="definition-text">{params.definitionText[index]}</span>
                                </li>
                            );
                        })}
                    </ul>
                </div>
                {
                    params.params &&
          <div className="container-editables">
              <span className="header-properties">{params.header}</span>
              <ul>{Array.isArray(params.params) && params.params.map((p, index) => {
                  return (p && <li className="param-properties" key={index}>{p}</li>);
              })}</ul>
          </div>
                }
            </div >
        );
    };

    //
    const BlockSimpleEdit = () => {
        return (
            <div className="container-selfhelp">
                <div className="row">
                    <div className="col-xs-12 text-md-left text-center col-md-1"><span className="selfHelpNumbers">1</span></div>
                    <div className="col">
                        <span className="selfHelpDescription">{t("selfHelp.farmInfo.msg1")}</span>
                        <div>
                            <img src={images.simple[0]} className='selfHelpImages' alt="selfHelp" />
                        </div>
                    </div>
                </div>
                <hr className="selfHelpLine" />
                <div className="row">
                    <div className="col-xs-12 text-md-left text-center col-md-1"><span className="selfHelpNumbers">2</span></div>
                    <div className="col">
                        <div className="selfHelpDescription">
                            <span>
                                {t("selfHelp.farmInfo.msg2")}
                            </span>
                        </div>
                        <div>
                            <img src={images.simple[1]} className='selfHelpImages' alt="selfHelp" />
                        </div>
                    </div>
                </div>
                <hr className="selfHelpLine" />
                <div className="row">
                    <div className="col-xs-12 text-md-left text-center col-md-1"><span className="selfHelpNumbers">3</span></div>
                    <div className="col">
                        <span className="selfHelpDescription">{t("selfHelp.tableButtons.msgSave")}</span>
                        <div>
                            <img src={import.meta.glob("../../img/autoayuda/*/autoayuda-farminfo-zonetable-buttons-1.png", { eager: true, import: "default" })[`../../img/autoayuda/${lng}/autoayuda-farminfo-zonetable-buttons-1.png`]} alt="selfHelp" />
                        </div>
                    </div>

                    <div className="col">
                        <span className="selfHelpDescription">{t("selfHelp.tableButtons.msgCancel")}</span>
                        <div>
                            <img src={import.meta.glob("../../img/autoayuda/*/autoayuda-farminfo-zonetable-buttons-2.png", { eager: true, import: "default" })[`../../img/autoayuda/${lng}/autoayuda-farminfo-zonetable-buttons-2.png`]} alt="selfHelp" />
                        </div>
                    </div>
                </div>
                <hr className="selfHelpLine" />
                <div className="row">
                    <div className="col-xs-12 text-md-left text-center col-md-1"><span className="selfHelpNumbers">4</span></div>
                    <div className="col">
                        <div className="row">
                            <div className="col">
                                <span className="selfHelpDescription">{t("selfHelp.msgSuccess")}</span>
                                <div>
                                    <img src={import.meta.glob("../../img/autoayuda/*/autoayuda-success.png", { eager: true, import: "default" })[`../../img/autoayuda/${lng}/autoayuda-success.png`]} className='selfHelpImages msg' alt="selfHelp" />
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col">
                                <span className="selfHelpDescription">{t("selfHelp.msgInfo")}</span>
                                <div>
                                    <img src={import.meta.glob("../../img/autoayuda/*/autoayuda-info.png", { eager: true, import: "default" })[`../../img/autoayuda/${lng}/autoayuda-info.png`]} className='selfHelpImages msg' alt="selfHelp" />
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col">
                                <span className="selfHelpDescription">{t("selfHelp.msgError")}</span>
                                <div>
                                    <img src={import.meta.glob("../../img/autoayuda/*/autoayuda-error.png", { eager: true, import: "default" })[`../../img/autoayuda/${lng}/autoayuda-error.png`]} className='selfHelpImages msg' alt="selfHelp" />
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        );
    };

    const BlockMassEdit = () => {
        return (
            <div className="container-selfhelp">
                <div className="row">
                    <div className="col-xs-12 text-md-left text-center col-md-1"><span className="selfHelpNumbers">1</span></div>
                    <div className="col">
                        <span className="selfHelpDescription">{t("selfHelp.massEdit.msg1")}</span>
                        <div>
                            <img src={images.mass[0]} className='selfHelpImages' alt="selfHelp" />
                        </div>
                    </div>
                </div>
                <hr className="selfHelpLine" />
                <div className="row">
                    <div className="col-xs-12 text-md-left text-center col-md-1"><span className="selfHelpNumbers">2</span></div>
                    <div className="col">
                        <div className="selfHelpDescription"><span>{t("selfHelp.massEdit.msg2")}</span></div>
                        <div>
                            <img src={images.mass[1]} className='selfHelpImages' alt="selfHelp" />
                        </div>
                    </div>
                </div>
                <hr className="selfHelpLine" />
                <div className="row">
                    <div className="col-xs-12 text-md-left text-center col-md-1"><span className="selfHelpNumbers">3</span></div>
                    <div className="col">
                        <span className="selfHelpDescription">{t("selfHelp.massEdit.msg3")}</span>
                        <div>
                            <img src={images.mass[2]} className='selfHelpImages' alt="selfHelp" />
                        </div>
                    </div>
                </div>
                <hr className="selfHelpLine" />
                <div className="row">
                    <div className="col-xs-12 text-md-left text-center col-md-1"><span className="selfHelpNumbers">4</span></div>
                    <div className="col">
                        <span className="selfHelpDescription">{t("selfHelp.massEdit.msg4")}</span>
                        <div>
                            <img src={images.mass[3]} className='selfHelpImages' alt="selfHelp" />
                        </div>
                    </div>
                </div>
                <hr className="selfHelpLine" />
                <div className="row">
                    <div className="col-xs-12 text-md-left text-center col-md-1"><span className="selfHelpNumbers">5</span></div>
                    <div className="col">
                        <div className="row">
                            <div className="col">
                                <span className="selfHelpDescription">{t("selfHelp.msgSuccess")}</span>
                                <div>
                                    <img src={import.meta.glob("../../img/autoayuda/*/autoayuda-success.png", { eager: true, import: "default" })[`../../img/autoayuda/${lng}/autoayuda-success.png`]} className='selfHelpImages msg' alt="selfHelp" />
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col">
                                <span className="selfHelpDescription">{t("selfHelp.msgInfo")}</span>
                                <div>
                                    <img src={import.meta.glob("../../img/autoayuda/*/autoayuda-info.png", { eager: true, import: "default" })[`../../img/autoayuda/${lng}/autoayuda-info.png`]} className='selfHelpImages msg' alt="selfHelp" />
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col">
                                <span className="selfHelpDescription">{t("selfHelp.msgError")}</span>
                                <div>
                                    <img src={import.meta.glob("../../img/autoayuda/*/autoayuda-error.png", { eager: true, import: "default" })[`../../img/autoayuda/${lng}/autoayuda-error.png`]} className='selfHelpImages msg' alt="selfHelp" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    };

    // Fenología
    const PhenologyTableHelpContent = () => {
        return (
            <div className="container-selfhelp">
                <div className="row">
                    <div className="col">
                        <img src={images.phenologyTable} className='selfHelpImages' style={{ width: "100%" }} alt="selfHelp" />
                    </div>
                </div>
                <hr className="selfHelpLine" />
                <div className="row">
                    <div className="col-xs-12 text-md-left text-center col-md-1"><span className="selfHelpNumbers">1</span></div>
                    <div className="col">
                        <span className="selfHelpDescription">{t("selfHelp.fenologiaTable.msgAdd")}</span>
                    </div>
                </div>
                <hr className="selfHelpLine" />
                <div className="row">
                    <div className="col-xs-12 text-md-left text-center col-md-1"><span className="selfHelpNumbers">2</span></div>
                    <div className="col">
                        <span className="selfHelpDescription">{t("selfHelp.fenologiaTable.msgEdit")}</span>
                    </div>
                </div>
                <hr className="selfHelpLine" />
                <div className="row">
                    <div className="col-xs-12 text-md-left text-center col-md-1"><span className="selfHelpNumbers">3</span></div>
                    <div className="col">
                        <span className="selfHelpDescription">{t("selfHelp.fenologiaTable.msgDel")}</span>
                        <div>
                            <img src={images.deleteDialog} className='selfHelpImages' style={{ width: "60%" }} alt="selfHelp" />
                        </div>
                    </div>
                </div>
            </div>
        );
    };

    const PhenologyFormHelpContent = () => {
        return (
            <div className="container-selfhelp">
                <div className="row">
                    <div className="col-xs-12 text-md-left text-center col-md-1"><span className="selfHelpNumbers">1</span></div>
                    <div className="col">
                        <span className="selfHelpDescription">{t("selfHelp.farmInfo.msg2")}</span>
                        <img src={images.phenologyForm} style={{ width: "100%" }} className='selfHelpImages' alt="selfHelp" />
                    </div>
                </div>
                <hr className="selfHelpLine" />
                <div className="row">
                    <div className="col-xs-12 text-md-left text-center col-md-1"><span className="selfHelpNumbers">2</span></div>
                    <div className="col">
                        <img src={images.estadosTable} style={{ width: "100%" }} className='selfHelpImages' alt="selfHelp" />
                        <span className="selfHelpDescription mt-2">
                            <p className="d-flex flex-column">
                                {t("selfHelp.fenologiaForm.msgAddStates")}
                                <img src={images.estadosForm} style={{ width: "60%" }} className='selfHelpImages align-self-center' alt="selfHelp" />

                            </p>
                            <p>
                                {t("selfHelp.fenologiaForm.msgDragStates")}
                            </p>
                            <p>
                                {t("selfHelp.fenologiaForm.msgEditStates")}
                            </p>
                            <p>
                                {t("selfHelp.fenologiaForm.msgDeleteStates")}
                            </p>
                            <p>
                                {t("selfHelp.fenologiaForm.msgSave")}
                            </p>
                            <p>
                                {t("selfHelp.fenologiaForm.msgCancel")}
                            </p>
                        </span>
                    </div>
                </div>
                <hr className="selfHelpLine" />
                <div className="row">
                    <div className="col-xs-12 text-md-left text-center col-md-1"><span className="selfHelpNumbers">3</span></div>
                    <div className="col">
                        <div className="row">
                            <div className="col">
                                <span className="selfHelpDescription">{t("selfHelp.msgSuccess")}</span>
                                <div>
                                    <img src={import.meta.glob("../../img/autoayuda/*/autoayuda-success.png", { eager: true, import: "default" })[`../../img/autoayuda/${lng}/autoayuda-success.png`]} className='selfHelpImages msg' alt="selfHelp" />
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col">
                                <span className="selfHelpDescription">{t("selfHelp.msgInfo")}</span>
                                <div>
                                    <img src={import.meta.glob("../../img/autoayuda/*/autoayuda-info.png", { eager: true, import: "default" })[`../../img/autoayuda/${lng}/autoayuda-info.png`]} className='selfHelpImages msg' alt="selfHelp" />
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col">
                                <span className="selfHelpDescription">{t("selfHelp.msgError")}</span>
                                <div>
                                    <img src={import.meta.glob("../../img/autoayuda/*/autoayuda-error.png", { eager: true, import: "default" })[`../../img/autoayuda/${lng}/autoayuda-error.png`]} className='selfHelpImages msg' alt="selfHelp" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    };

    const ReportsMassEdition = () => {
        return (
            <div className="container-selfhelp">
                <div className="row">
                    <div className="col-xs-12 text-md-left text-center col-md-1"><span className="selfHelpNumbers">1</span></div>
                    <div className="col">
                        <span className="selfHelpDescription">{t("selfHelp.massEdit.msg1")}</span>
                        <div>
                            <img src={images?.[2]?.[0]} className='selfHelpImages' alt="selfHelp" />
                        </div>
                    </div>
                </div>
                <hr className="selfHelpLine" />
                <div className="row">
                    <div className="col-xs-12 text-md-left text-center col-md-1"><span className="selfHelpNumbers">2</span></div>
                    <div className="col">
                        <div className="selfHelpDescription"><span>{t("selfHelp.massEdit.msg2")}</span></div>
                        <div>
                            <img src={images?.[2]?.[1]} className='selfHelpImages' alt="selfHelp" />
                        </div>
                    </div>
                </div>
                <hr className="selfHelpLine" />
                <div className="row">
                    <div className="col-xs-12 text-md-left text-center col-md-1"><span className="selfHelpNumbers">3</span></div>
                    <div className="col">
                        <span className="selfHelpDescription">{t("selfHelp.massEdit.msg3")}</span>
                        <div>
                            <img src={images?.[2]?.[2]} className='selfHelpImages'  alt="selfHelp" />
                        </div>
                    </div>
                </div>
                <hr className="selfHelpLine" />
                <div className="row">
                    <div className="col-xs-12 text-md-left text-center col-md-1"><span className="selfHelpNumbers">4</span></div>
                    <div className="col">
                        <span className="selfHelpDescription">{t("selfHelp.massEdit.msg4")}</span>
                        <div>
                            <img src={images?.[2]?.[3]} className='selfHelpImages'  alt="selfHelp" />
                        </div>
                    </div>
                </div>
                <hr className="selfHelpLine" />
                <div className="row">
                    <div className="col-xs-12 text-md-left text-center col-md-1"><span className="selfHelpNumbers">5</span></div>
                    <div className="col">
                        <div className="row">
                            <div className="col">
                                <span className="selfHelpDescription">{t("selfHelp.msgSuccess")}</span>
                                <div>
                                    <img src={import.meta.glob("../../img/autoayuda/*/autoayuda-success.png", { eager: true, import: "default" })[`../../img/autoayuda/${lng}/autoayuda-success.png`]} className='selfHelpImages msg' alt="selfHelp" />
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col">
                                <span className="selfHelpDescription">{t("selfHelp.msgInfo")}</span>
                                <div>
                                    <img src={import.meta.glob("../../img/autoayuda/*/autoayuda-info.png", { eager: true, import: "default" })[`../../img/autoayuda/${lng}/autoayuda-info.png`]} className='selfHelpImages msg' alt="selfHelp" />
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col">
                                <span className="selfHelpDescription">{t("selfHelp.msgError")}</span>
                                <div>
                                    <img src={import.meta.glob("../../img/autoayuda/*/autoayuda-error.png", { eager: true, import: "default" })[`../../img/autoayuda/${lng}/autoayuda-error.png`]} className='selfHelpImages msg' alt="selfHelp" />
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        );
    };

    const ReportsAdd = () => {
        return (
            <div className="container-selfhelp">
                <div className="row">
                    <div className="col-xs-12 text-md-left text-center col-md-1"><span className="selfHelpNumbers">1</span></div>
                    <div className="col">
                        <span className="selfHelpDescription">{t("selfHelp.reportesForm.msgAdd1")}</span>
                        <div>
                            <img src={images?.[3]?.[0]} className='selfHelpImages' alt="selfHelp" />
                        </div>
                    </div>
                </div>
                <hr className="selfHelpLine" />
                <div className="row">
                    <div className="col-xs-12 text-md-left text-center col-md-1"><span className="selfHelpNumbers">2</span></div>
                    <div className="col">
                        <div className="selfHelpDescription"><span>{t("selfHelp.reportesForm.msgAdd2")}</span></div>
                        <div>
                            <img src={images?.[3]?.[1]} className='selfHelpImages' alt="selfHelp" />
                        </div>
                    </div>
                </div>
                <hr className="selfHelpLine" />
                <hr className="selfHelpLine" />
                <div className="row">
                    <div className="col-xs-12 text-md-left text-center col-md-1"><span className="selfHelpNumbers">3</span></div>
                    <div className="col">
                        <span className="selfHelpDescription">{t("selfHelp.tableButtons.msgSave")}</span>
                        <div>
                            <img src={import.meta.glob("../../img/autoayuda/*/autoayuda-farminfo-zonetable-buttons-1.png", { eager: true, import: "default" })[`../../img/autoayuda/${lng}/autoayuda-farminfo-zonetable-buttons-1.png`]} alt="selfHelp" />
                        </div>
                    </div>

                    <div className="col">
                        <span className="selfHelpDescription">{t("selfHelp.tableButtons.msgCancel")}</span>
                        <div>
                            <img src={import.meta.glob("../../img/autoayuda/*/autoayuda-farminfo-zonetable-buttons-2.png", { eager: true, import: "default" })[`../../img/autoayuda/${lng}/autoayuda-farminfo-zonetable-buttons-2.png`]} alt="selfHelp" />
                        </div>
                    </div>
                </div>
                <hr className="selfHelpLine" />
                <div className="row">
                    <div className="col-xs-12 text-md-left text-center col-md-1"><span className="selfHelpNumbers">5</span></div>
                    <div className="col">
                        <div className="row">
                            <div className="col">
                                <span className="selfHelpDescription">{t("selfHelp.msgSuccess")}</span>
                                <div>
                                    <img src={import.meta.glob("../../img/autoayuda/*/autoayuda-success.png", { eager: true, import: "default" })[`../../img/autoayuda/${lng}/autoayuda-success.png`]} className='selfHelpImages msg' alt="selfHelp" />
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col">
                                <span className="selfHelpDescription">{t("selfHelp.msgInfo")}</span>
                                <div>
                                    <img src={import.meta.glob("../../img/autoayuda/*/autoayuda-info.png", { eager: true, import: "default" })[`../../img/autoayuda/${lng}/autoayuda-info.png`]} className='selfHelpImages msg' alt="selfHelp" />
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col">
                                <span className="selfHelpDescription">{t("selfHelp.msgError")}</span>
                                <div>
                                    <img src={import.meta.glob("../../img/autoayuda/*/autoayuda-error.png", { eager: true, import: "default" })[`../../img/autoayuda/${lng}/autoayuda-error.png`]} className='selfHelpImages msg' alt="selfHelp" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    };

    const PriceListAdd = () => {
        return (
            <div className="container-selfhelp">
                <div className="row">
                    <div className="col-xs-12 text-md-left text-center col-md-1"><span className="selfHelpNumbers">1</span></div>
                    <div className="col">
                        <span className="selfHelpDescription">{t("selfHelp.priceList.instructions.msg1")}</span>
                        <div><img src={images[0]} className='selfHelpImages' alt="selfHelp" /></div>
                    </div>
                </div>
                <hr className="selfHelpLine" />
                <div className="row">
                    <div className="col-xs-12 text-md-left text-center col-md-1"><span className="selfHelpNumbers">2</span></div>
                    <div className="col">
                        <span className="selfHelpDescription">{t("selfHelp.priceList.instructions.msg2")}</span>
                        <div><img src={images[1]} className='selfHelpImages' alt="selfHelp" /></div>
                    </div>
                </div>
                <hr className="selfHelpLine" />
                <div className="row">
                    <div className="col-xs-12 text-md-left text-center col-md-1"><span className="selfHelpNumbers">3</span></div>
                    <div className="col">
                        <span className="selfHelpDescription">{t("selfHelp.priceList.instructions.msg3")}</span>
                        <div><img src={images[2]} className='selfHelpImages' alt="selfHelp" /></div>
                    </div>
                </div>
                <hr className="selfHelpLine" />
                <div className="row">
                    <div className="col-xs-12 text-md-left text-center col-md-1"><span className="selfHelpNumbers">4</span></div>
                    <div className="col">
                        <div className="selfHelpDescription"><span>{t("selfHelp.priceList.instructions.msg4")}</span></div>
                        <div><img src={images[3]} className='selfHelpImages' alt="selfHelp" /></div>
                    </div>
                </div>
                <hr className="selfHelpLine" />
                <div className="row">
                    <div className="col-xs-12 text-md-left text-center col-md-1"><span className="selfHelpNumbers">5</span></div>
                    <div className="col">
                        <div className="selfHelpDescription"><span><b>{t("selfHelp.priceList.instructions.msg5")}</b></span></div>
                        <div><img src={images[4]} className='selfHelpImages' alt="selfHelp" /></div>
                    </div>
                </div>
                <hr className="selfHelpLine" />
                <div className="row">
                    <div className="col-xs-12 text-md-left text-center col-md-1"><span className="selfHelpNumbers">6</span></div>
                    <div className="col">
                        <span className="selfHelpDescription">{t("selfHelp.priceList.instructions.msg6")}</span>
                        <div><img src={images[5]} className='selfHelpImages' alt="selfHelp" /></div>
                    </div>
                </div>
                <hr className="selfHelpLine" />
                <div className="row">
                    <div className="col-xs-12 text-md-left text-center col-md-1"><span className="selfHelpNumbers">7</span></div>
                    <div className="col">
                        <span className="selfHelpDescription">{t("selfHelp.farmInfo.msg3")}</span>
                        <div><img src={editButtonGreen} className='selfHelpImages buttons' alt="selfHelp" /></div>
                    </div>
                    <div className="col">
                        <span className="selfHelpDescription">{t("selfHelp.farmInfo.msg4")}</span>
                        <div><img src={editButtonRed} className='selfHelpImages buttons' alt="selfHelp" /></div>
                    </div>
                </div>
                <hr className="selfHelpLine" />
                <div className="row">
                    <div className="col-xs-12 text-md-left text-center col-md-1"><span className="selfHelpNumbers">8</span></div>
                    <div className="col">
                        <div className="row">
                            <div className="col">
                                <span className="selfHelpDescription">{t("selfHelp.msgSuccess")}</span>
                                <div><img src={images[6]} className='selfHelpImages msg' alt="selfHelp" /></div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col">
                                <span className="selfHelpDescription">{t("selfHelp.priceList.instructions.msgError")}</span>
                                <div><img src={images[7]} className='selfHelpImages msg' alt="selfHelp" /></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    };
    const PropertiesReport = () => {
        if (!params) return null;
        return (
            <div className="container-properties">
                <div className="containter-definitions">
                    <span className="header-properties">{t("selfHelp.definitionsHeader")}</span>
                    <ul>
                        {Array.isArray(params.definitionName) && Array.isArray(params.definitionText) && params.definitionName.map((p, index) => {
                            if (p === t("automaticReports.timeRange")){
                                return (
                                    <li className="param-properties" key={index}>
                                        <span className="definition-name">{p}: </span>
                                        <span className="definition-text">{params.definitionText[index]}</span>
                                        <ul>
                                            <li>
                                                {t("selfHelp.definitions.reportes.timeRangeWindow") + ": 1 "
                        + t("automaticReports.week") + ", 2 "
                        + t("automaticReports.weeks") + ", 1 "
                        + t("automaticReports.month") + ", 3 "
                        + t("automaticReports.months") + ", 6 "
                        + t("automaticReports.months") + ", 1 "
                        + t("automaticReports.year") + ", 2 "
                        + t("automaticReports.years") + ", 3 " + t("automaticReports.years")}
                                            </li>
                                            <li>
                                                {t("selfHelp.definitions.reportes.timeRangeCurrent") + ": "
                        + t("automaticReports.today") + ", "
                        + t("automaticReports.thisWeek") + ", "
                        + t("automaticReports.thisMonth") + ", "
                        + t("automaticReports.thisYear")}
                                            </li>
                                        </ul>
                                    </li>
                                );
                            }
                            return (
                                <li className="param-properties" key={index}>
                                    <span className="definition-name">{p}: </span>
                                    <span className="definition-text">{params.definitionText[index]}</span>
                                </li>
                            );
                        })}
                    </ul>
                </div>
            </div>
        );
    };
    return (
        <div>
            <TooltipPrime id="toolSelfHelp"  content={t("helpTooltip")} position="bottom" >
                <FontAwesomeIcon className='pointer' onClick={() => setDialogState(true)} size="lg" icon={faQuestionCircle} style={{ color: "lightblue" }} />
            </TooltipPrime>
            <Dialog
                id='dialogSelfHelp'
                className='dialog-prime'
                transitionOptions={{ effect: "Zoom", duration: 300, delay: 0 }}
                visible={dialogState}
                onHide={() => setDialogState(false)}
                style={{width:"650px",height:"90%"}}
                ref={selfHelpRef}
                header={t("selfHelp.needHelp")}
            >
                <div>

                    {dialogState &&
            <>
                {zonesTableEditable ?
                    <TabView className='tab-prime-selfhelp'>
                        <TabPanel header={tabNamesIfZonesTable[0].text} >
                            {SimpleEdition()}
                        </TabPanel>
                        <TabPanel header={tabNamesIfZonesTable[1].text} >
                            {MassEdition()}
                        </TabPanel>
                        <TabPanel header={tabNamesIfZonesTable[2].text} >
                            {PropertiesZone()}
                        </TabPanel>
                    </TabView>
                    :
                    simpleEditTable ?
                        <TabView className='tab-prime-selfhelp'>
                            <TabPanel header={tabNames[0].text} >
                                {SimpleEdition()}
                            </TabPanel>
                        </TabView>
                        :
                        userTable ?
                            <TabView className='tab-prime-selfhelp'>
                                <TabPanel header={tabNamesUserTable[0].text} >
                                    {SimpleEdition()}
                                </TabPanel>
                                <TabPanel header={tabNamesUserTable[1].text} >
                                    {AddUser()}
                                </TabPanel>
                            </TabView>
                            :
                            blockTable ?
                                <TabView className='tab-prime-selfhelp'>
                                    <TabPanel header={tabNamesIfZonesTable[0].text} >
                                        {BlockSimpleEdit()}
                                    </TabPanel>
                                    <TabPanel header={tabNamesIfZonesTable[1].text} >
                                        {BlockMassEdit()}
                                    </TabPanel>
                                </TabView>
                                :
                                fertiTable ?
                                    <HelperFertiTable t={t} params={params} lng={lng} />
                                    :
                                    nodeSensTable ?
                                        <HelperNodeSensTable t={t} params={params} lng={lng} />
                                        :
                                        target === "PhenologyTable" ?
                                            <TabView className='tab-prime-selfhelp'>
                                                <TabPanel header={tabNames[0].text} >
                                                    {PhenologyTableHelpContent()}
                                                </TabPanel>
                                            </TabView>
                                            :
                                            target === "ReportesTable" ?
                                                <TabView id='defaultTab' style={{width:"99%"}} className='tab-prime-selfhelp'>
                                                    <TabPanel header={tabNamesReportsTable[0].text} >
                                                        {ReportsAdd()}
                                                    </TabPanel>
                                                    <TabPanel header={tabNamesReportsTable[1].text} >
                                                        {SimpleEdition()}
                                                    </TabPanel>
                                                    {/*<TabPanel header={tabNamesReportsTable[2].text} >
                    {ReportsMassEdition}
                  </TabPanel>*/}
                                                    <TabPanel header={tabNamesReportsTable[3].text} >
                                                        {PropertiesReport()}
                                                    </TabPanel>
                                                </TabView>
                                                :
                                                target === "PhenologyForm" ?
                                                    <TabView className='tab-prime-selfhelp'>
                                                        <TabPanel header={tabNames[0].text} >
                                                            {PhenologyFormHelpContent()}
                                                        </TabPanel>
                                                        <TabPanel header={tabNames[1].text} >
                                                            {Properties()}
                                                        </TabPanel>
                                                    </TabView>
                                                    :
                                                    target === "PriceList" ?
                                                        <TabView className='tab-prime-selfhelp'>
                                                            <TabPanel header={tabNames[0].text} >
                                                                {PriceListAdd()}
                                                            </TabPanel>
                                                            <TabPanel header={tabNames[1].text} >
                                                                {PropertiesReport()}
                                                            </TabPanel>
                                                        </TabView>
                                                        :
                                                        <TabView className='tab-prime-selfhelp'>
                                                            {!onlyDict &&
                  <TabPanel header={tabNames[0].text} >
                      {nodeMap ? InstructionsNodeMap() : (zoneMap ? InstructionsZoneMap() : Instructions())}
                  </TabPanel>}
                                                            {params &&
                  <TabPanel header={tabNames[1].text} >
                      {zoneForm ? PropertiesZone() : Properties()}
                  </TabPanel>}
                                                        </TabView>}

            </>}
                </div>
            </Dialog>
        </div>);
};

export default SelfHelp;
